import { render } from "./FixtureCard.vue?vue&type=template&id=2874fa00&scoped=true"
import script from "./FixtureCard.vue?vue&type=script&lang=js"
export * from "./FixtureCard.vue?vue&type=script&lang=js"

import "./FixtureCard.vue?vue&type=style&index=0&id=2874fa00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2874fa00"]])

export default __exports__